import React from "react";
import { FieldArray } from "formik";
import { Card, CardBody, CardHeader, Table, Button, Label } from "reactstrap";
import { Link } from "react-router-dom";
import InputField from "../../Utils/InputField";

const PricingModelTableRecurring = ({
  pricingModelNew = [],
  onChangePricingModel,
  onAddRow,
  onDeleteRow,
  isSubscribed = false,
  triggerError,
}) => {
  const canAddRow = () => {
    return pricingModelNew.every(
      (row) =>
        row.startingUnit !== "" &&
        row.endingUnit !== "" &&
        row.pricePerUnit !== ""
    );
  };

  const onResetRow = (idx) => {
    onChangePricingModel("startingUnit", idx, "");
    onChangePricingModel("endingUnit", idx, "");
    onChangePricingModel("pricePerUnit", idx, "");
  };

  return (
    <div className="table-responsive mx-3 my-3">
      <Label className="rv-form-label mb-0 ms-1">Tier Pricing</Label>
      <Table className="table-borderless align-middle table-nowrap mb-0">
        <thead>
          <tr>
            <th style={{ width: "25%" }}>Starting Unit</th>
            <th style={{ width: "25%" }}>Ending Unit</th>
            <th style={{ width: "25%" }}> Price Per Unit</th>
            <th style={{ width: "25%" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {pricingModelNew?.map((val, idx) => (
            <tr key={idx}>
              <td>
                <InputField
                  placeholder="Enter Starting Unit"
                  type="number"
                  className={
                    triggerError && !val?.startingUnit ? "error-input" : ""
                  }
                  handleChange={(e) =>
                    onChangePricingModel("startingUnit", idx, e.target.value)
                  }
                  value={val?.startingUnit}
                  disabled={isSubscribed}
                />
              </td>
              <td>
                <InputField
                  placeholder="Enter Ending Unit"
                  type="number"
                  className={
                    triggerError && !val?.endingUnit ? "error-input" : ""
                  }
                  handleChange={(e) =>
                    onChangePricingModel("endingUnit", idx, e.target.value)
                  }
                  value={val?.endingUnit}
                  disabled={isSubscribed}
                />
              </td>
              <td>
                <InputField
                  placeholder="Enter Price Per Unit"
                  type="number"
                  className={
                    triggerError && !val?.pricePerUnit ? "error-input" : ""
                  }
                  handleChange={(e) =>
                    onChangePricingModel("pricePerUnit", idx, e.target.value)
                  }
                  value={val?.pricePerUnit}
                  disabled={isSubscribed}
                />
              </td>
              <td>
                <div className="hstack gap-3 fs-15">
                  {idx === 0 ? (
                    <>
                      {" "}
                      <Link
                        to="#"
                        className="link-danger"
                        onClick={() => {
                          if (canAddRow()) {
                            onAddRow();
                          }
                        }}
                      >
                        <i
                          data-testid="add"
                          className="ri-add-circle-line fs-5"
                        ></i>
                      </Link>{" "}
                      <Link
                        to="#"
                        className="link-danger"
                        onClick={() => onResetRow(idx)}
                      >
                        <i
                          data-testid="delete"
                          className="ri-eraser-line fs-5"
                        ></i>
                      </Link>
                    </>
                  ) : (
                    <Link
                      to="#"
                      className="link-danger"
                      onClick={() => onDeleteRow(idx)}
                    >
                      <i
                        data-testid="delete"
                        className="ri-delete-bin-5-line"
                      ></i>
                    </Link>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default PricingModelTableRecurring;
